// extracted by mini-css-extract-plugin
var _1 = "TemplatesView-module__empty--V2N8i";
var _2 = "TemplatesView-module__title--ZyMYB";
export { _1 as "empty", _2 as "title" }
